import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { addDays, format, isWeekend } from "date-fns";
import { Observable, map, shareReplay } from "rxjs";

declare type HolidaysType = {
  [key: string]: {
    division: string, events: [{
      bunting: boolean,
      title: string,
      date: string,
      notes: string
    }]
  }
};

@Injectable({
  providedIn: 'root'
})
export class DateService {

  private holidays: Observable<HolidaysType>;

  constructor(
    private http: HttpClient
  ) {
    this.holidays = http.get<HolidaysType>('https://www.gov.uk/bank-holidays.json').pipe(shareReplay(1));
  }

  public getDays(start: Date, count: number, filter?: (date: Date) => boolean) {
    const ret: Date[] = [];

    for (let dt = start; ret.length < count; dt = addDays(dt, 1)) {
      if (filter && !filter(dt))
        continue;

      ret.push(dt);
    }

    return ret;
  }

  public getWorkDays$(start: Date, count: number) {

    return this.holidays.pipe(
      map(x => x['england-and-wales']),
      map(x => x.events.reduce((pv, x) => {
        pv[x.date] = x;
        return pv;
      }, <{ [key: string]: any }>{})),
      map(holidays => {
        return this.getDays(start, count, dt => !isWeekend(dt) && !holidays[format(dt, 'yyyy-MM-dd')]);
      })
    );
  }

}


